import { LayoutDashboard, CalendarCheck, CalendarRange, Wallet, Truck, Users, BarChart3, ChevronDown, Search, Bell, TrendingUp } from "lucide-react";

const nav = [
  { icon: LayoutDashboard, label: "Tableau de bord", active: true },
  { icon: CalendarCheck, label: "Réservations" },
  { icon: CalendarRange, label: "Planning" },
  { icon: Wallet, label: "Caisse" },
  { icon: Truck, label: "Flotte" },
  { icon: Users, label: "Équipe" },
  { icon: BarChart3, label: "Statistiques" },
];

const kpis = [
  { label: "CA encaissé", value: "24 680 €", delta: "+18%", tone: "text-turquoise" },
  { label: "Réservations", value: "128", delta: "+12", tone: "text-brand" },
  { label: "Participants", value: "342", delta: "+9%", tone: "text-violet" },
  { label: "Dépenses", value: "3 940 €", delta: "-6%", tone: "text-navy/40" },
];

const bookings = [
  { name: "Quad Atlas — 4 pers.", time: "10:00", price: "680 €", status: "Confirmée", tone: "bg-turquoise/10 text-turquoise" },
  { name: "Jet-ski — Duo 30 min", time: "11:30", price: "450 €", status: "En attente", tone: "bg-amber-100 text-amber-600" },
  { name: "Buggy Dunes — 2 pers.", time: "14:00", price: "1 120 €", status: "Confirmée", tone: "bg-turquoise/10 text-turquoise" },
];

const DashboardMockup = () => (
  <div data-testid="hero-dashboard-mockup" className="overflow-hidden rounded-2xl border border-slate-200 bg-white text-left shadow-lift">
    <div className="flex">
      <aside className="hidden w-44 shrink-0 flex-col bg-navy p-4 md:flex">
        <div className="flex items-center gap-2">
          <img src="/actipilote-icon.png" alt="" className="h-7 w-7 rounded-md bg-white/10 p-0.5" />
          <span className="text-sm font-extrabold text-white">ActiPilote</span>
        </div>
        <button className="mt-4 flex items-center justify-between rounded-lg bg-white/10 px-3 py-2 text-[11px] font-semibold text-white/90">
          Agadir Centre <ChevronDown className="h-3 w-3" />
        </button>
        <nav className="mt-4 space-y-1">
          {nav.map((item) => (
            <div key={item.label} className={`flex items-center gap-2.5 rounded-lg px-3 py-2 text-[11px] font-semibold ${item.active ? "bg-brand text-white" : "text-white/50 hover:text-white/80"}`}>
              <item.icon className="h-3.5 w-3.5" /> {item.label}
            </div>
          ))}
        </nav>
        <div className="mt-auto flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2">
          <div className="flex h-6 w-6 items-center justify-center rounded-full bg-turquoise text-[10px] font-bold text-navy">YA</div>
          <div>
            <p className="text-[10px] font-bold text-white">Y. Alaoui</p>
            <p className="text-[9px] text-white/40">Gérant</p>
          </div>
        </div>
      </aside>

      <div className="min-w-0 flex-1 bg-mist/60 p-4 sm:p-5">
        <div className="flex items-center justify-between gap-3">
          <h3 className="text-sm font-extrabold text-navy sm:text-base">Tableau de bord</h3>
          <div className="flex items-center gap-2">
            <div className="hidden items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] text-navy/50 sm:flex">
              <Search className="h-3 w-3" /> Rechercher…
            </div>
            <div className="relative rounded-full border border-slate-200 bg-white p-1.5">
              <Bell className="h-3.5 w-3.5 text-navy/60" />
              <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-brand" />
            </div>
            <span className="rounded-full bg-navy px-3 py-1.5 text-[10px] font-bold text-white">Aujourd'hui</span>
          </div>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-4">
          {kpis.map((k) => (
            <div key={k.label} className="rounded-xl border border-slate-200/80 bg-white p-3 shadow-soft">
              <p className="text-[10px] font-semibold uppercase tracking-wide text-navy/45">{k.label}</p>
              <p className="mt-1 font-mono text-base font-bold text-navy sm:text-lg">{k.value}</p>
              <p className={`mt-0.5 text-[10px] font-bold ${k.tone}`}>{k.delta} cette sem.</p>
            </div>
          ))}
        </div>

        <div className="mt-3 grid gap-3 lg:grid-cols-5">
          <div className="rounded-xl border border-slate-200/80 bg-white p-4 shadow-soft lg:col-span-3">
            <div className="flex items-center justify-between">
              <p className="text-xs font-bold text-navy">Revenus de la semaine</p>
              <span className="flex items-center gap-1 rounded-full bg-turquoise/10 px-2 py-0.5 text-[10px] font-bold text-turquoise">
                <TrendingUp className="h-3 w-3" /> +24%
              </span>
            </div>
            <svg viewBox="0 0 300 110" className="mt-3 w-full" aria-hidden="true">
              <defs>
                <linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#2563EB" stopOpacity="0.22" />
                  <stop offset="100%" stopColor="#2563EB" stopOpacity="0" />
                </linearGradient>
              </defs>
              {[22, 46, 70, 94].map((y) => (
                <line key={y} x1="0" y1={y} x2="300" y2={y} stroke="#E2E8F0" strokeWidth="1" />
              ))}
              <path d="M0,88 C30,80 45,60 70,64 C95,68 110,40 140,44 C170,48 185,28 215,30 C245,32 265,14 300,18 L300,110 L0,110 Z" fill="url(#chartFill)" />
              <path d="M0,88 C30,80 45,60 70,64 C95,68 110,40 140,44 C170,48 185,28 215,30 C245,32 265,14 300,18" fill="none" stroke="#2563EB" strokeWidth="2.5" strokeLinecap="round" />
              <circle cx="215" cy="30" r="4" fill="#2563EB" stroke="#fff" strokeWidth="2" />
            </svg>
            <div className="mt-1 flex justify-between font-mono text-[9px] text-navy/40">
              {["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map((d) => <span key={d}>{d}</span>)}
            </div>
          </div>

          <div className="rounded-xl border border-slate-200/80 bg-white p-4 shadow-soft lg:col-span-2">
            <p className="text-xs font-bold text-navy">Réservations récentes</p>
            <div className="mt-3 space-y-2.5">
              {bookings.map((b) => (
                <div key={b.name} className="flex items-center justify-between gap-2 rounded-lg bg-mist/70 px-3 py-2">
                  <div className="min-w-0">
                    <p className="truncate text-[11px] font-bold text-navy">{b.name}</p>
                    <p className="font-mono text-[10px] text-navy/45">{b.time}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-mono text-[11px] font-bold text-navy">{b.price}</p>
                    <span className={`rounded-full px-1.5 py-0.5 text-[9px] font-bold ${b.tone}`}>{b.status}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DashboardMockup;
